<template>
    <div class="about-box" ref="aboutUs">
        <el-row class="mb-54">
            <el-col :span="21" :offset="3">
                <div class="nav-title">
                    <span>关于我们</span>
                    <span>/</span>
                    <span>About us</span>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :xl="9" :lg="9" :md="6" :offset="3">
                <img src="../assets/images/about.png" alt="" srcset="" width="100%" height="100%">
            </el-col>
            <el-col :xl="9" :lg="11" :md="14" class="text-box">
                <div class="p-box">
                    <span></span>
                    <p>
                        诚优佳(北京)装饰工程有限公司成立于<i>2010</i>年，公司注册资本金为2000万元，是专门从事建筑工程、钢结构工程、装饰装修工程、工程设计为一体的建筑装饰企业，公司以信誉诚质量优、服务佳的企业理念服务社会。
                    </p>
                </div>
                <div class="p-box">
                    <span></span>
                    <p>
                        自有资产，北京市石景山区<i> 180 </i>平米办公场所，厂区占地占地 <i>45</i> 亩，其中生产车间14000余平，办公楼 <i>7000</i> 余平。
                    </p>
                </div>
                <div class="p-box">
                    <span></span>
                    <p>
                        旗下拥有杭州分公司、河南分公司。全资企业:周口柯丰木业有限公司，以木制品定制及家具定制、防盗门防火门生产。为周口市淮阳区重点工业项目。
                    </p>
                </div>
                <div class="chunk-box">
                    <div>
                        <h1>14<span>+</span></h1>
                        <h4>年生产经验</h4>
                        <p>14 years of production experience</p>
                    </div>
                    <div>
                        <h1>45<span>+</span></h1>
                        <h4>亩厂区占地</h4>
                        <p>45 acres of factory area</p>
                    </div>
                    <div>
                        <h1>180<span>+</span></h1>
                        <h4>m2北京办公区</h4>
                        <p>180㎡ Beijing office area</p>
                    </div>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import { EventBus } from '../js/eventBus';

export default {
    props:['winWidth'],
    mounted() {
        EventBus.$on('aboutUs', this.someOtherMethod);
    },
    beforeDestroy() {
        EventBus.$off('aboutUs', this.someOtherMethod);
    },
    methods: {
        someOtherMethod(param) {
            const anchorElement = this.$refs['aboutUs'];
            if (anchorElement) {
                // anchorElement.scrollIntoView({ behavior: 'smooth' });
                window.scrollTo({
                    top: this.winWidth.about,
                    behavior: 'smooth'
                });
            }
        }
    }
}
</script>
<style scoped lang="scss">
.about-box {
    padding: 90px 0;
    background:#f3F3F5;
}

.text-box {
    padding-top: 10px;
}

.p-box {
    display: flex;
    margin-left: 56px;
    align-items: flex-start;

    i {
        color: #CFA886;
        font-style: normal;
    }

    span {
        width: 18px;
        height: 18px;
        background-color: #CFA886;
        transform: rotate(130deg);
        margin-right: 20px;
        margin-top: 14px;
    }

    p {
        flex: 1;
        font-weight: 400;
        font-size: 16px;
        color: #3F3F3F;
        line-height: 36px;
    }
}

.chunk-box {
    display: flex;
    margin-left: 56px;
    margin-top: 46px;

    div {
        flex: 220px 0 0;
        background: linear-gradient(180deg, #D5AF8E 0%, #AD7F5A 100%);
        border-radius: 10px;
        color: #FFFDFB;
        text-align: center;
        padding: 24px 0 24px 0;
        font-weight: 400;
        margin-right: 10px;

        &:last-child {
            margin-right: 0 !important;
        }
    }

    h1 {
        font-weight: 600;
        font-size: 60px;
        margin-bottom: 5px;
        position: relative;

        span {
            position: absolute;
            top: -0px;
            font-size: 40px;
        }
    }

    h4 {
        font-size: 18px;
        margin-bottom: 5px;
    }

    p {
        font-size: 12px;
    }
}

/* 当屏幕宽度小于或等于1600像素时，应用以下样式 */
@media (max-width: 1600px) {
    .p-box {
        display: flex;
        margin-left: 56px;
        align-items: flex-start;
        margin-bottom: 10px;

        span {
            width: 18px;
            height: 18px;
            background-color: #CFA886;
            transform: rotate(130deg);
            margin-right: 20px;
            margin-top: 14px;
        }

        p {
            flex: 1;
            font-weight: 400;
            font-size: 14px;
            color: #3F3F3F;
            line-height: 24px;
        }
    }

    .chunk-box {
        display: flex;
        margin-left: 56px;
        margin-top: 20px;

        div {
            flex: 180px 0 0;
            padding: 12px 0 12px 0;
        }

        h1 {
            font-weight: 600;
            font-size: 30px;
            margin-bottom: 5px;
            position: relative;

            span {
                position: absolute;
                top: -0px;
                font-size: 20px;
            }
        }

        h4 {
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}

@media (min-width: 1921px) {
    .p-box {
        display: flex;
        margin-left: 56px;
        align-items: flex-start;
        margin-bottom: 10px;
        p {
            flex: 1;
            font-weight: 400;
            font-size: 18px;
            color: #3F3F3F;
            line-height: 36px;
            margin-bottom: 20px;
        }
    }

    
}
</style>